var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_34162)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.774414 1.5V21C0.774414 21.83 1.44441 22.5 2.27441 22.5H23.2744C24.1044 22.5 24.7744 21.83 24.7744 21V1.5H0.774414ZM23.2744 5.19H6.60775V3H23.2744V5.19ZM5.10775 3V5.19H2.27441V3H5.10775ZM2.27441 21V6.69H23.2744V21H2.27441Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0044 10.25H12.7244V11.75H22.0044V10.25Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6811 13.3033H12.7177V14.8033H18.6811V13.3033Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3577 9.83333H4.52441C4.11108 9.83333 3.77441 10.17 3.77441 10.5833V16.4167C3.77441 16.83 4.11108 17.1667 4.52441 17.1667H10.3577C10.7711 17.1667 11.1077 16.83 11.1077 16.4167V10.5833C11.1077 10.17 10.7711 9.83333 10.3577 9.83333ZM9.60775 15.6667H5.27441V11.3333H9.60775V15.6667Z",
    fill: "#415385"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_34162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.774414)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.78ace07cb96d6f48fc8d11de9a3535ce.svg";
export { ForwardRef as ReactComponent };